import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { money, imgSrc } from "../../lib/api";

export const Badge = ({ children, id }) => (
  <span data-testid={id} className="rounded-full border border-violet-300/40 bg-violet-200/80 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-violet-700 backdrop-blur">
    {children}
  </span>
);

export const StockDot = ({ stock, id }) => (
  <span data-testid={id} className={`flex shrink-0 items-center gap-2 text-sm ${stock > 0 ? "text-emerald-400" : "text-rose-400"}`}>
    <span className={`h-2 w-2 rounded-full ${stock > 0 ? "bg-emerald-400 shadow-[0_0_8px_#34d399]" : "bg-rose-400"}`} />
    {stock > 0 ? `${stock} left` : "Sold out"}
  </span>
);

export const ProductCard = ({ p, i }) => (
  <motion.article
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
    data-testid={`product-card-${p.id}`}
    className="group flex flex-col overflow-hidden rounded-2xl border border-white/[0.07] bg-[#1a1633] transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1 hover:border-violet-500/50 hover:shadow-[0_20px_60px_-20px_rgba(139,92,246,0.45)]"
  >
    <Link to={`/product/${p.id}`} className="relative block aspect-[16/10] overflow-hidden" data-testid={`product-image-link-${p.id}`}>
      <img src={imgSrc(p.image)} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-[#1a1633] to-transparent" />
      <div className="absolute left-4 top-4"><Badge id={`product-badge-${p.id}`}>{p.badge}</Badge></div>
    </Link>
    <div className="flex flex-1 flex-col px-6 pb-6 pt-4">
      <div className="flex items-start justify-between gap-4">
        <h3 className="font-display text-lg font-medium uppercase text-white">{p.title}</h3>
        <StockDot stock={p.stock} id={`product-stock-${p.id}`} />
      </div>
      <p className="mb-6 mt-3 flex-1 text-base text-zinc-400">{p.subtitle}</p>
      <div className="flex items-center justify-between border-t border-white/[0.07] pt-5">
        <div data-testid={`product-price-${p.id}`}>
          <span className="font-display text-3xl font-semibold text-white">{money(p.price)}</span>
          <span className="ml-1.5 text-sm text-zinc-400">USD</span>
        </div>
        <Link to={`/product/${p.id}`} data-testid={`product-view-button-${p.id}`} className="btn-primary">View</Link>
      </div>
    </div>
  </motion.article>
);
